import { Component } from 'react';
import { Link } from 'react-router-dom';
import branch from 'hocs/branch';

import { ROOT } from '../../../../constants';
import CategoryListItem from './CategoryListItem';
import SidebarNav from './SidebarNav';

class Sidebar extends Component {
  state = {
    isMobileNavOpened: false,
    currentId: this.props.currentCategoryId,
  };

  componentDidUpdate(prevProps) {
    if (this.props.currentCategoryId !== prevProps.currentCategoryId) {
      this.setState({ currentId: this.props.currentCategoryId });
    }
  }

  toggleMobileNavOpened = () =>
    this.setState(prevState => ({
      isMobileNavOpened: !prevState.isMobileNavOpened,
    }));

  handleCategoryClick = id => this.setState({ currentId: id });

  render() {
    const { categories, collectionName } = this.props;

    const { isMobileNavOpened, currentId } = this.state;

    return (
      <div className="section__sidebar">
        <div className="breadcrumbs section__breadcrumbs _mb-23">
          <span className="breadcrumbs__item section__breadcrumbs-item">
            <Link
              className="breadcrumbs__link section__breadcrumbs-link"
              to={ROOT}
            >
              Help Center
            </Link>
          </span>
          <span className="breadcrumbs__item section__breadcrumbs-item">
            {collectionName}
          </span>
        </div>
        <SidebarNav
          collectionName={collectionName}
          isOpened={isMobileNavOpened}
          toggleOpened={this.toggleMobileNavOpened}
        >
          <ul className="search-nav__category-list">
            {categories.map(({ id, articles, name }) => (
              <CategoryListItem
                id={id}
                articles={articles}
                isOpen={currentId === id}
                key={id}
                name={name}
                onClick={this.handleCategoryClick}
                onLinkClick={this.toggleMobileNavOpened}
              />
            ))}
          </ul>
        </SidebarNav>
      </div>
    );
  }
}

export default branch(Sidebar);
